import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const slug = 'commercial-solar-power-solutions-sydney';
const serviceId = 2
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Commercial Solar Power Solutions Sydney | ${BUSINESS_NAME}`,
        description: "Cost-effective energy for businesses across Sydney. We help companies reduce overheads and boost sustainability with scalable solar systems.",
        keywords: "commercial solar power solutions Sydney, business solar installations, commercial solar systems, energy-efficient business solutions, solar panel installation for businesses, sustainable energy Sydney, corporate solar solutions, commercial renewable energy, solar maintenance for businesses, reduce business energy costs",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Commercial Solar Power Solutions',
    description: 'Cost-effective energy for businesses across Sydney. We help companies reduce overheads and boost sustainability with scalable solar systems.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
